export interface IPage<T> {
  page: number
  page_size: number
  total_records: number
  total_pages: number
  data: T[]
}

export const DEFAULT_PAGE_SIZES = [10, 25, 50, 100]
export const DEFAULT_PAGINATION_LAYOUT = 'sizes, prev, pager, next, total'
